import React from 'react';
import { StyledBundlePrice, StyledBundlePriceButton } from './style';
import { PMBundlePriceProps } from 'utils/types';
import { ActualPrice } from 'components/BundlePrice/ActualPrice';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

export const LightningLinkCasinoBundlePrice: React.FC<PMBundlePriceProps> = ({
  prices,
  bundleButtonColor,
  bundleButtonTextColor = 'white',
  fontFamily,
}) => {
  return (
    <StyledBundlePriceButton>
      <StyledBundlePrice
        bundleButtonColor={bundleButtonColor}
        bundleButtonTextColor={bundleButtonTextColor}
        fontFamily={fontFamily}
      >
        <div className="lightning-link-casino__price-button totalPrice">
          <AutoTextSize
            mode="oneline"
            maxFontSizePx={16}
            minFontSizePx={4}
            flexGrow="1"
          >
            <ActualPrice
              prices={prices}
              textShadow={
                '0px 1px 1px rgba(0, 0, 0, 0.3), -0.5px 0.5px 0 rgb(0, 101, 43), 0.5px -0.5px 0 rgb(0, 101, 43),-0.5px -0.5px 0 rgb(0, 101, 43), 0.5px 0.5px 0 rgb(0, 101, 43)'
              }
            />
          </AutoTextSize>
        </div>
      </StyledBundlePrice>
    </StyledBundlePriceButton>
  );
};
